import script from "./order-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./order-list.vue?vue&type=script&lang=ts&setup=true"

import "./order-list.vue?vue&type=style&index=0&id=0791776f&lang=scss&scoped=true"

import exportComponent from "D:\\web\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0791776f"]])

export default __exports__